import { useSystemMutation } from '@features/redux/apis/system';
import { MutationEffect } from '@helpers/MutationEffect';
import { useAlert } from '@hooks/useAlert';

export const ForceEffects = () => {
    const { setAlert } = useAlert();

    const [, mutationState] = useSystemMutation({
        fixedCacheKey: 'ForceOffsetMutation',
    });

    return (
        <>
            <MutationEffect
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                mutationState={mutationState}
                effects={{
                    isError: () => {
                        setAlert('Unable to update force offset.', 'error');
                        mutationState.reset();
                    },
                    isSuccess: () => {
                        setAlert('Successfully updated force offset', 'success');
                        mutationState.reset();
                    },
                }}
            />
        </>
    );
};
